import { cn } from '~/lib/utils'

export function Notice({
  tone = 'danger',
  children,
  className,
}: {
  tone?: 'danger' | 'success'
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(
        'border px-[14px] py-[10px] font-mono text-[12px] tracking-[0.06em]',
        tone === 'danger'
          ? 'border-danger text-danger'
          : 'border-success text-success',
        className,
      )}
    >
      {children}
    </div>
  )
}
